<template>
  <el-dialog
    :model-value="visible"
    title="Visualizar API Key"
    width="600px"
    @close="handleClose"
  >
    <div
      v-if="apiKey.Codigo"
      class="api-key-container"
    >
      <div class="info-section">
        <div class="info-label">Descripción:</div>
        <div class="info-value">{{ apiKey.Descripcion }}</div>
      </div>

      <div class="info-section">
        <div class="info-label">API Key:</div>
        <div style="display: flex">
          <div class="api-key-display">
            <code>{{ apiKey.Apikey }}</code>
          </div>
          <el-button
            :icon="IconContentCopy"
            size="default"
            @click="copyToClipboard(apiKey.Apikey)"
          />
        </div>
      </div>
    </div>
  </el-dialog>
</template>

<script setup>
import { onBeforeMount } from 'vue';
import { storeToRefs } from 'pinia';
import { useApiKeysStore } from './apiKeys_store';
import { useMessageError } from '@/shared/composables/message_error.js';
import { useMessageSuccess } from '@/shared/composables/message_success.js';
import { useLoading } from '@/shared/composables/loading.js';
import IconContentCopy from '~icons/mdi/content-copy';

const apiKeysStore = useApiKeysStore();
const { apiKey } = storeToRefs(apiKeysStore);

const props = defineProps({
  visible: {
    type: Boolean,
    default: false,
  },
  apiKeyId: {
    type: Number,
    default: null,
  },
});

const emit = defineEmits(['close']);

const copyToClipboard = async () => {
  if (!apiKey.value?.Apikey) return;

  try {
    await navigator.clipboard.writeText(apiKey.value.Apikey);
    useMessageSuccess().open('API Key copiada al portapapeles');
    handleClose();
  } catch (error) {
    useMessageError().open('Error al copiar al portapapeles');
  }
};

const handleClose = () => {
  emit('close');
};

onBeforeMount(async () => {
  try {
    useLoading().openLoading();
    await apiKeysStore.findApiKeyHTTP(props.apiKeyId);
  } catch (error) {
    useMessageError().open(error);
  } finally {
    useLoading().closeLoading();
  }
});
</script>

<style scoped>
.api-key-container {
  padding: 10px 0;
}

.info-section {
  margin-bottom: 20px;
}

.info-label {
  font-weight: 600;
  color: #606266;
  margin-bottom: 8px;
  font-size: 14px;
}

.info-value {
  color: #303133;
  font-size: 15px;
}

.api-key-display {
  background-color: #f5f7fa;
  border: 1px solid #dcdfe6;
  border-radius: 4px;
  padding: 4px 12px;
  word-break: break-all;
}

.api-key-display code {
  font-family: 'Fira Code', 'Courier New', monospace;
  color: #e83e8c;
  font-size: 0.8rem;
}
</style>
